import { Suspense, useState, useEffect, useRef } from "react";
import reportsServices from '../../services/reports/reportservice';
import AppLoading from '../app-loading/app-loading';
import { Toast } from "primereact/toast";
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

export const TreemapChart = () => {

    const toast = useRef<Toast>(null);
    const [loading, setLoading] = useState(false);
    const today = new Date();
    const [year, setYear] = useState<any>(today.getFullYear());
    const [currentMonth, setCurrentMonth] = useState<any>(today.getMonth() + 1);
    const remainingDays = new Date(year, currentMonth, 0).getDate() - today.getDate();
    const [responseData, setResponseData] = useState<any>();

    const [rawTotals, setRawTotals] = useState({
        target: 0,
        targetReached: 0,
        remainingTargetPerDay: 0,
        targetReachedPercentage: 0.0
    });

    const monthNames = [
        { "id": 1, "month": "January" },
        { "id": 2, "month": "February" },
        { "id": 3, "month": "March" },
        { "id": 4, "month": "April" },
        { "id": 5, "month": "May" },
        { "id": 6, "month": "June" },
        { "id": 7, "month": "July" },
        { "id": 8, "month": "August" },
        { "id": 9, "month": "September" },
        { "id": 10, "month": "October" },
        { "id": 11, "month": "November" },
        { "id": 12, "month": "December" }
    ];

    const [selectedMonth, setSelectedMonth] = useState<any>(monthNames.filter(x => x.id === currentMonth)[0]);
     const par = { month: selectedMonth.id, year: year };
    const nFormatter = (amount: number): string => {
        return (amount / 100000).toFixed(2).replace(/\.00$/, '') + 'L';
    };


    type POSNode = {
        name: string;
        size?: string;
        color?: string;
        targetReached?: string;
        target?: string;
        month?: string;
        children?: POSNode[];
    };

    const FeatchData = async () => {
        setLoading(true);
        let filterData : POSNode[] = [];

        let totalTarget = 0;
        let totalReached = 0;
        let totalRemainingPerDay = 0;

        await reportsServices.getPOSTargetMappingMonthList(par).then((respones: any) => {
            if (respones.length > 0) {
                for (let index = 0; index < respones.length; index++) {
                    const res = respones[index];
                    const remainingTargetPerMonth = Math.round(res.target - res.invoiceAmount) / remainingDays;

                    totalTarget += res.target;
                    totalReached += res.invoiceAmount;
                    totalRemainingPerDay += currentMonth === selectedMonth.id
                        ? (remainingTargetPerMonth < 0 ? 0 : remainingTargetPerMonth)
                        : 0;

                    var objdata: POSNode = {
                        name: res.pos,
                        size: Math.round((res.invoiceAmount / res.target) * 100) > 100
                            ? "100%"
                            : Math.round((res.invoiceAmount / res.target) * 100) + "%",
                        color: res.color,
                        targetReached: nFormatter(Math.round(res.invoiceAmount)),
                        target: nFormatter(Math.round(res.target)),
                        month: currentMonth === selectedMonth.id
                            ? nFormatter(remainingTargetPerMonth < 0 ?  0 : remainingTargetPerMonth)
                            : nFormatter(0)
                    };

                    filterData.push(objdata);
                }
            }
            setResponseData(filterData);
            setRawTotals({
                target: totalTarget,
                targetReached: totalReached,
                remainingTargetPerDay: totalRemainingPerDay,
                targetReachedPercentage : (totalReached/totalTarget * 100) > 100 ? 100 : (totalReached/totalTarget * 100)
            });
            setLoading(false);
        });
    };

    useEffect(() => {
        FeatchData();
    }, []);

    return (
        <Suspense fallback={<AppLoading />}>
            <Toast ref={toast} />
            <div className="layout-content mt-3 mb-3 grid grid-table-mobile">
                <div className="col-12">
                    <div className="flex align-items-center justify-content-between flex-wrap gap-2 w-full card-container mb-0">
                        <h5 className="ml-1 mb-0">POS Target Mapping Report Details</h5>
                    </div>
                </div>
                <div className='grid'>
                    <div className="col-12 sm:col-4 lg:col-6 font-bold text-white border-round">
                        <InputText
                            id="Year"
                            name="Year"
                            keyfilter="int"
                            value={year}
                            onChange={(e) => setYear(e.target.value)}
                            placeholder={year + "#"} style={{ width: "100%" }}
                            disabled
                        />
                    </div>
                    <div className="col-12 sm:col-4 lg:col-6 font-bold text-white border-round">
                        <Dropdown value={selectedMonth} onChange={(e) => setSelectedMonth(e.value)} options={monthNames} optionLabel="month"
                            placeholder="Select a Month" />
                    </div>
                </div>
                <div className='grid'>
                    <div className="col-12 sm:col-6 lg:col-12 font-bold text-white border-round">
                        <Button className=" text-black border-round" style={{ width: "100%" }} onClick={FeatchData} severity="success">Filter</Button>
                    </div>
                </div>
                <div className="col-12 card border-noround p-2">
                <div className="flex justify-content-start mb-2">
                    <div className="flex align-items-center gap-2 p-2 border-round" 
                        style={{  backgroundColor: 'var(--blue-50)',  border: '1px solid var(--blue-100)', display: 'inline-flex', maxWidth: 'fit-content' }}>
                        <i className="pi pi-info-circle" style={{ color: 'var(--blue-600)', fontSize: '1.25rem' }} />
                        <span style={{ color: 'var(--blue-700)' }}>All amounts are exclusive of taxes.</span>
                    </div>
                </div>
                    {responseData !== null &&
                        <DataTable
                            editMode="row"
                            value={responseData}
                            paginator
                            rows={10}
                            rowsPerPageOptions={[5, 10, 25, 50, 100]}
                            stripedRows
                            showGridlines
                            emptyMessage="No order found."
                            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                            currentPageReportTemplate="{first} to {last} of {totalRecords}"
                        >
                            <Column field="name" header="Name" style={{ width: '20%',fontSize:"1.3rem"}} footer="Total:" />
                            <Column field="target" header="Target Per Month "  style={{ width: '20%' ,fontSize:"1.3rem", textAlign :"center"}} footer={nFormatter(rawTotals.target)} />
                            <Column field="targetReached" header={ selectedMonth.id === currentMonth ? "Target Achieved (as on " +  new Date(today).toLocaleDateString("en-gb", {
                                    day: "2-digit",
                                    month: "short",
                                    year: "numeric",
                                }) + ")" : "Target Achieved"} style={{ width: '20%',fontSize:"1.3rem" , textAlign :"center" }} footer={nFormatter(rawTotals.targetReached)} />
                            <Column field="month" header={ selectedMonth.id === currentMonth ? ("Target Per Day For Remaning (" + remainingDays + ") Days") : "Target Per Day For Remaning Days"} style={{ width: '20%' ,fontSize:"1.3rem" , textAlign :"center"}} footer={nFormatter(rawTotals.remainingTargetPerDay)} />
                            <Column field={"size"} header="Target Achived (%)" style={{ width: '20%',fontSize:"1.3rem" , textAlign :"center" }} footer={(rawTotals.targetReachedPercentage).toFixed(2) + "%"} />
                        </DataTable>
                    }
                </div>
            </div>
            {loading && <AppLoading />}
        </Suspense>
    );
};
